import { render, staticRenderFns } from "./simulasi_penetapan.vue?vue&type=template&id=66ccf369&"
import script from "./simulasi_penetapan.vue?vue&type=script&lang=js&"
export * from "./simulasi_penetapan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports